import storage from "@storage";

export const OPEN_WIDGETS = "layoutActions::openWidgets";
export const CLOSE_WIDGETS = "layoutActions::closeWidgets";
export const CREATE_MOBILE_MENU = "layoutActions::createMobileMenu";
export const REMOVE_MOBILE_MENU = "layoutActions::removeMobileMenu";
export const OPEN_MOBILE_MENU = "layoutActions::openMobileMenu";
export const CLOSE_MOBILE_MENU = "layoutActions::closeMobileMenu";
export const EXPAND_SIDEBAR = "layoutActions::expandSideBar";
export const COLLAPSE_SIDEBAR = "layoutActions::collapseSideBar";
export const CHANGE_COLUMN_VIEW = "layoutActions::changeColumnView";
export const SET_THEME = "layoutActions::setTheme";
export const SET_FIXED_SIDEBAR = "layoutActions::setFixedSidebar";
export const TOGGLE_ADD_ACCOUNT = "layoutActions::toggleAddAccount";
export const OPEN_ADD_ACCOUNT = "layoutActions::openAddAccount";
export const CLOSE_ADD_ACCOUNT = "layoutActions::closeAddAccount";
export const CHANGE_DENSITY = "layoutActions::changeDensity";

export const openWidgets = () => {
  return {
    type: OPEN_WIDGETS
  };
};

export const setFixedSidebar = payload => {
  return {
    type: SET_FIXED_SIDEBAR,
    payload
  };
};

export const closeWidgets = () => {
  return {
    type: CLOSE_WIDGETS
  };
};

export const createMobileMenu = () => {
  return {
    type: CREATE_MOBILE_MENU
  };
};

export const removeMobileMenu = () => {
  return {
    type: REMOVE_MOBILE_MENU
  };
};

export const openMobileMenu = () => {
  return {
    type: OPEN_MOBILE_MENU
  };
};

export const closeMobileMenu = () => {
  return {
    type: CLOSE_MOBILE_MENU
  };
};

export const expandSidebar = () => {
  return {
    type: EXPAND_SIDEBAR
  };
};

export const collapseSidebar = () => {
  return {
    type: COLLAPSE_SIDEBAR
  };
};

export const changeColumnView = val => dispatch => {
  storage.set("columnView", val);

  dispatch({
    type: CHANGE_COLUMN_VIEW,
    payload: {
      columnView: val
    }
  });
};

export const setTheme = theme => {
  return {
    type: SET_THEME,
    payload: {
      theme
    }
  };
};

export const toggleAddAccount = () => {
  return {
    type: TOGGLE_ADD_ACCOUNT
  };
};

export const openAddAccount = () => {
  return {
    type: OPEN_ADD_ACCOUNT
  };
};

export const closeAddAccount = () => {
  return {
    type: CLOSE_ADD_ACCOUNT
  };
};

export const changeDensity = val => dispatch => {
  storage.set("density", val);

  dispatch({
    type: CHANGE_DENSITY,
    payload: {
      density: val
    }
  });
};
